import React, { useEffect, useMemo } from 'react';
import { ConsentConfiguration, PersonalDataConfiguration } from '@luckycart/xpn-types';

import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { PersonalDataContainer } from './PersonalData.style';
import { Email } from './Email';
import { Phone } from './Phone';

export interface Props {
  suOptinForm?: boolean;
  personalDataConfig: PersonalDataConfiguration[];
  consentsConfig: ConsentConfiguration[];
  isEdition?: boolean;
  addEditableBlock?: (block: BlockInfoType) => void;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  displayName: string;
  dataTemplateConfig: string;
  testId?: string;
  availableData: Record<string, string | undefined | null>
}

export const PersonalData: React.FunctionComponent<Props> = ({
  suOptinForm,
  personalDataConfig,
  consentsConfig,
  isEdition,
  addEditableBlock,
  onBlockEdit,
  displayName,
  dataTemplateConfig,
  testId,
  availableData,
} : Props) => {
	
  /* ! Currently only use by SU, this is adapted to work only with SU Data ! 
** Disclaimer : no choice here, I have to do it this way for now 
*/
  const dataTemplateType = 'personal-data';
  const computedPersonalData = useMemo<Array<PersonalDataConfiguration & {disabled?:boolean}>>(() => {
    if (suOptinForm === true) {
      return personalDataConfig
        .filter(({ activated }) => activated)
        .filter(({ key }) => consentsConfig[0].key === key);
    }
	
    return personalDataConfig
      .filter(({ activated }) => activated)
      .sort(({ position: positionA }, { position: positionB }) => positionA - positionB)
      .map((data: PersonalDataConfiguration & { disabled?: boolean }) => {
        return {
          ...data,
          disabled: typeof availableData[data.key] === 'string'
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- fuck dumb eslint
            // @ts-ignore
            ? availableData[data.key].trim().length > 0
            : false,
        };
      });
  }, [personalDataConfig, availableData, consentsConfig, suOptinForm]);

  useEffect(
    () => {
      if (addEditableBlock) {
        addEditableBlock({
          blockType: dataTemplateType,
          configPath: dataTemplateConfig,
          label: displayName,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataTemplateConfig]
  );

  return (
    <PersonalDataContainer
      suOptinForm={suOptinForm}
      isEdition={isEdition}
      data-template-type={dataTemplateType}
      data-display-name={displayName}
      data-config-path={dataTemplateConfig}
      data-testid={testId}
      onClick={onBlockEdit}
    >
      {computedPersonalData.map(({ type, placeholderText, labelHtml, key, disabled }) => {	
        switch (type) {
        case 'phone':
          return (
            <Phone
              name={`personalData.${key}`}
              key={key}
              placeholderText={availableData.phone ?? ''}
              labelHtml={labelHtml}
              disabled
            />
          );
        case 'email':
          return (
            <Email
              suOptinForm={suOptinForm}
              name={`personalData.${key}`}
              key={key}
              placeholderText={availableData.email ?? placeholderText}
              labelHtml={labelHtml}
              disabled={disabled}
            />
          );
        default:
          return null;
        }
      })}
    </PersonalDataContainer>
  );
};
